import { gql } from '@apollo/client';
import { EXPORT_INSTITUTION } from '../../fragments';

export const EXPORT_ATTENDANCE_SCHOOLS = gql`
  query ExportAttendanceSchools($input: ExportArgs!) {
    institutions: allAttendanceSchools(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...exportInstitution
        }
      }
    }
  }
  ${EXPORT_INSTITUTION}
`;
